// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.utUb80p0C3UcdpLQ1Iuq.utUb80p0C3UcdpLQ1Iuq {
  cursor: pointer
}

.utUb80p0C3UcdpLQ1Iuq.utUb80p0C3UcdpLQ1Iuq:hover {
    -webkit-text-decoration-line: underline;
            text-decoration-line: underline;
  }

@media only screen and
  (min-width: 1280px) {
  .utUb80p0C3UcdpLQ1Iuq {
    font-size: 1.125rem;
    line-height: 1.5rem;
  }
}

@media only screen and
  (min-width: 1024px) and
  (max-width: 1279px) {
  .utUb80p0C3UcdpLQ1Iuq {
    font-size: 1.125rem;
    line-height: 1.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/BackArrowLink/BackArrowLink.module.css"],"names":[],"mappings":"AAAA;EACE;AAKF;;AAHE;IACE,uCAA+B;YAA/B,+BAA+B;EACjC;;AAGF;;EACE;IACE,mBAAe;IACf,mBAAiB;EACnB;AACF;;AAEA;;;EACE;IACE,mBAAe;IACf,mBAAiB;EACnB;AACF","sourcesContent":[".backArrowLink.backArrowLink {\n  cursor: pointer;\n\n  &:hover {\n    text-decoration-line: underline;\n  }\n}\n\n@media (--desktop-large) {\n  .backArrowLink {\n    font-size: 18px;\n    line-height: 24px;\n  }\n}\n\n@media (--desktop-small) {\n  .backArrowLink {\n    font-size: 18px;\n    line-height: 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"backArrowLink": `utUb80p0C3UcdpLQ1Iuq`
};
export default ___CSS_LOADER_EXPORT___;
